import classNames from 'classnames';

import type { ECouponPriceSplashProps } from './ECouponPriceSplash.types';

import styles from './ECouponPriceSplash.module.scss';

type ECouponPriceSplashSkeletonProps = Pick<ECouponPriceSplashProps, 'size'>;

const ECouponPriceSplashSkeleton = ({ size = 'default' }: ECouponPriceSplashSkeletonProps) => {
    return (
        <span
            className={classNames(styles.Skeleton, size === 'small' && styles.SizeSmall)}
            aria-hidden
        />
    );
};

export default ECouponPriceSplashSkeleton;
